export default "__VITE_ASSET__CYi6pbu2__"